import { call, put, takeLatest } from 'redux-saga/effects';

import { GET_SECURITY_UNLOADING_REPORTS_REQUEST } from './constants';
import { SecurityUnloadingReportService } from './service';
import {
  getSecurityUnloadingReportsError,
  getSecurityUnloadingReportsRequest,
  getSecurityUnloadingReportsSuccess,
} from './actions';
import { SecurityUnloadingReport } from './interfaces';

function* getUnloadingReportsSaga(action: ReturnType<typeof getSecurityUnloadingReportsRequest>) {
  try {
    const { startDate, endDate, branchId } = action.payload;

    const reports: SecurityUnloadingReport[] = yield call(
      SecurityUnloadingReportService.getReports,
      startDate,
      endDate,
      branchId,
    );
    yield put(getSecurityUnloadingReportsSuccess(SecurityUnloadingReportService.formatReportForTable(reports)));
  } catch (error: any) {
    yield put(getSecurityUnloadingReportsError(error));
  }
}

export function* reportUndloadingSagaWatcher() {
  yield takeLatest(GET_SECURITY_UNLOADING_REPORTS_REQUEST, getUnloadingReportsSaga);
}
